export default __webpack_public_path__ + "static/ABCtouchfreerightfreeplain-a745a37b2c657748a249d7132305f705.svg";